<script>
  import Drawer, { AppContent, Content as DrawerContent } from "@smui/drawer";
  import Button from "@smui/button";
  import IconButton from "@smui/icon-button";
  import Accordion, {
    Panel,
    Header,
    Content as AccordionContent,
  } from "@smui-extra/accordion";
  import List, { Item, Text } from "@smui/list";
  import { empty, onMount } from "svelte/internal";

  var artists = [];
  var openArtist;
  var albums = [];
  var openAlbum;
  var songs = [];

  fetch("https://throbbing-forest-4663.fly.dev/music")
    .then((response) => {
      return response.json();
    })
    .then((data) => {
      artists = data["artists"];
    });

  function getAlbums(artist) {
    albums = [];
    openArtist = artist;
    fetch(`https://throbbing-forest-4663.fly.dev/music/${artist}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        albums = data["albums"];
      });
  }

  function getSongs(album) {
    songs = [];
    openAlbum = album;
    fetch(`https://throbbing-forest-4663.fly.dev/music/${openArtist}/${album}`)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        songs = data["songs"];
      });
  }

  var queueSong;
  var nextSong;
  var jumpSong;
  var removeSong;
  var queue = [];
  var queuePos = 0;

  onMount(() => {
    document.getElementById("player").preload = "auto";
    document.getElementById("player").volume = 0.1;

    queueSong = function (song) {
      queue.push({
        song,
        artist: openArtist,
        album: openAlbum,
        pos: queue.length,
      });
      queue = queue;
      if (queue.length == 1) {
        nextSong();
      }
    };

    nextSong = function () {
      if (queue.length != 0) {
        let s = queue[queuePos];
        document.getElementById(
          "player"
        ).src = `https://throbbing-forest-4663.fly.dev/music/${s.artist}/${s.album}/${s.song}`;
        document.getElementById("player").load();
        document.getElementById("player").play();
        queuePos += 1;
      }
    };

    jumpSong = function (pos) {
      let s = queue[pos];
      document.getElementById(
        "player"
      ).src = `https://throbbing-forest-4663.fly.dev/music/${s.artist}/${s.album}/${s.song}`;
      document.getElementById("player").load();
      document.getElementById("player").play();
      queuePos = pos + 1;
    };

    removeSong = function (pos) {
      if (queuePos - 1 == pos) {
        queuePos = 0;
        document.getElementById("player").src = "";
        document.getElementById("player").load();
        queue.splice(pos, 1);
        queue = queue;
      } else {
        queue.splice(pos, 1);
        queue = queue;
      }

      queue.forEach((element) => {
        element.pos = queue.indexOf(element);
      });
    };

    document.getElementById("player").addEventListener("ended", () => {
      if (queuePos == queue.length) {
        queuePos = 0;
        document.getElementById("player").src = "";
        document.getElementById("player").load();
        queue = [];
      } else {
        nextSong();
      }
    });
  });
</script>

<main
  style="background-color: #2c001e; padding: 2em; margin-bottom: 0; border-bottom: 1px solid white;"
>
  <audio id="player" src="" type="audio/mpeg" style="width: 100%;" controls />
</main>

<div class="drawer-container" style="border: none; height:50.4em;">
  <div style="height: 100%;">
    <Drawer>
      <DrawerContent>
        <List>
          {#each artists as artist}
            <Item on:click={getAlbums(artist)}>
              <h3 style="color: white">{artist}</h3>
            </Item>
          {/each}
        </List>
      </DrawerContent>
    </Drawer>
  </div>

  <AppContent class="app-content">
    <main
      class="main-content"
      style="height: 50.4em; padding: 0px; background-color: #2c001e;"
    >
      {#if openArtist}
        <Accordion>
          {#each albums as a}
            <Panel on:click={getSongs(a)}>
              <Header>
                <div>
                  <img
                    alt={`${a} album cover`}
                    style="vertical-align: middle; height: 100px; display: inline-block;"
                    src={`https://throbbing-forest-4663.fly.dev/music/${openArtist}/${a}/cover`}
                  />
                  <h3 style="display: inline-block; margin-left: 1em;">{a}</h3>
                </div>
              </Header>
              <AccordionContent>
                <List>
                  {#each songs as song}
                    <Item on:click={queueSong(song)}>
                      <Text>{song}</Text>
                    </Item>
                  {/each}
                </List>
              </AccordionContent>
            </Panel>
          {/each}
        </Accordion>
      {:else}
        <p style="margin-left: 1em;">Select an artist to see their albums.</p>
      {/if}
    </main>
  </AppContent>

  <List
    style="width: 25rem; padding: 1em; margin: 1em; border: 1px dashed white"
  >
    <h1 style="margin-top: 0.2em">Queue</h1>
    <Button on:click={nextSong} variant="raised" color="secondary">
      Next Song
    </Button>
    {#if queue.length != 0}
      {#each queue as q}
        <Item style="align-items: center; background-color: #2c001e;">
          {#if q.pos == queuePos - 1}
            <b>{q.song} - {q.artist}</b>
          {:else}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <p on:click={jumpSong(q.pos)}>{q.song} - {q.artist}</p>
          {/if}
          <IconButton
            on:click={removeSong(q.pos)}
            class="material-icons"
            size="button"
            style="margin-left: 1em; margin-top: 0.5em;">delete</IconButton
          >
        </Item>
      {/each}
    {:else}
      <p><em>Queue a song to get started!</em></p>
    {/if}
  </List>
</div>

<style>
  /* These classes are only needed because the
	  drawer is in a container on the page. */
  .drawer-container {
    position: relative;
    display: flex;
    border: 1px solid
      var(--mdc-theme-text-hint-on-background, rgba(0, 0, 0, 0.1));
    overflow: hidden;
    z-index: 0;
  }

  * :global(.app-content) {
    flex: auto;
    overflow: auto;
    position: relative;
    flex-grow: 1;
  }

  .main-content {
    overflow: auto;
    padding: 16px;
    height: 100%;
    box-sizing: border-box;
  }
</style>
